export const formatDate = (iso) => {
  if (!iso) return "";
  const parts = iso.split("-");
  if (parts.length !== 3) return iso;
  const [y, m, d] = parts;
  return `${d}.${m}.${y}.`;
};

export const AGE_CATEGORIES = [
  { name: "Baby", range: "4-6 god" },
  { name: "Djeca I", range: "7-9 god" },
  { name: "Djeca II", range: "10-11 god" },
  { name: "Junior I", range: "12-13 god" },
  { name: "Junior II", range: "14-15 god" },
  { name: "Youth", range: "16-18 god" },
  { name: "Adult I", range: "19-25 god" },
  { name: "Adult II", range: "26-35 god" },
  { name: "Senior", range: "36-55 god" },
  { name: "Senior II", range: "56-65 god" },
];

export const CATEGORY_COLORS = {
  "Baby": "bg-pink-100 text-pink-800 border-pink-300",
  "Djeca I": "bg-orange-100 text-orange-800 border-orange-300",
  "Djeca II": "bg-amber-100 text-amber-800 border-amber-300",
  "Junior I": "bg-lime-100 text-lime-800 border-lime-300",
  "Junior II": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Youth": "bg-teal-100 text-teal-800 border-teal-300",
  "Adult I": "bg-sky-100 text-sky-800 border-sky-300",
  "Adult II": "bg-indigo-100 text-indigo-800 border-indigo-300",
  "Senior": "bg-violet-100 text-violet-800 border-violet-300",
  "Senior II": "bg-rose-100 text-rose-800 border-rose-300",
  "Van kategorije": "bg-gray-100 text-gray-700 border-gray-300",
};
